export const ExteriorSignageQuoteStatusEnumValue = {
  Active: 10,
  Submitted: 30,

  PendingQuote: 40,
  PendingDealerApproval: 50,
  PendingShippingDate: 60,
  PendingDelivery: 65,
  PendingInstallation: 70,
  PendingPictures: 75,

  Completed: 80,
  Cancelled: 100,
};

export const ExteriorSignageQuoteStatusEnum = [
  {
    value: ExteriorSignageQuoteStatusEnumValue.Active,
    name: 'Active',
    labelFrench: 'Actif',
    labelEnglish: 'Active',
    order: 1,
  },
  {
    value: ExteriorSignageQuoteStatusEnumValue.Submitted,
    name: 'Submitted',
    labelFrench: 'En traitement',
    labelEnglish: 'In Process',
    order: 2,
  },
  {
    value: ExteriorSignageQuoteStatusEnumValue.PendingQuote,
    name: 'PendingQuote',
    labelFrench: 'En attente de soumission',
    labelEnglish: 'Pending quote',
    order: 3,
  },
  {
    value: ExteriorSignageQuoteStatusEnumValue.PendingDealerApproval,
    name: 'PendingDealerApproval',
    labelFrench: "En attente d'approbation du concessionnaire",
    labelEnglish: 'Pending dealer approval',
    order: 4,
  },
  {
    value: ExteriorSignageQuoteStatusEnumValue.PendingShippingDate,
    name: 'PendingShippingDate',
    labelFrench: "Date d'expédition en attente",
    labelEnglish: 'Pending Shipping Date',
    order: 5,
  },
  {
    value: ExteriorSignageQuoteStatusEnumValue.PendingDelivery,
    name: 'PendingDelivery',
    labelFrench: 'En attente de livraison',
    labelEnglish: 'Pending Delivery',
    order: 6,
  },
  {
    value: ExteriorSignageQuoteStatusEnumValue.PendingInstallation,
    name: 'PendingInstallation',
    labelFrench: "En attente d'installation",
    labelEnglish: 'Pending Installation',
    order: 7,
  },
  {
    value: ExteriorSignageQuoteStatusEnumValue.PendingPictures,
    name: 'PendingPictures',
    labelFrench: 'Photos en attente',
    labelEnglish: 'Pending Pictures',
    order: 8,
  },

  {
    value: ExteriorSignageQuoteStatusEnumValue.Completed,
    name: 'Completed',
    labelFrench: 'Complété',
    labelEnglish: 'Completed',
    order: 9,
  },
  {
    value: ExteriorSignageQuoteStatusEnumValue.Cancelled,
    name: 'Cancelled',
    labelFrench: 'Annulé',
    labelEnglish: 'Cancelled',
    order: 10,
  },
];

export default ExteriorSignageQuoteStatusEnum;
